module.exports = __webpack_public_path__ + "img/essg4.475861f7.jpg";